<template>
  <stub-page header="Отписка от рассылки" :message="message" :isUnsubscribe="true" />
</template>
<script>
export default {
  name: 'Unsubscribed',

  props: {
    e_mail: {
      type: String,
      default: null
    },
  },

  computed: {
    message() {
      return `Вы отписались от ежемесячной рассылки квитанций на почту ${this.e_mail}`
    }
  },

  created: async function() {
    try {
      const resp = await this.$api.Account.unsubscribe(this.e_mail)
    } catch (e) {
      const err = e
      console.error(e)
    }
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
